import React, { useState, useRef, ChangeEventHandler } from "react";
import ContainerToggleConfigurar from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";

import { Toggle } from "../Toggle";
export interface ToggleMask {
  param?(value: any, param: any): unknown;
  mask: (value: string, param?: any) => string;
  unmask?: (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => string;
  maskValidation?: (value: string, inputElement: HTMLInputElement) => boolean;
}
interface ToggleConfigurarProps {
  nome?: string;
  value: boolean;
  onChange: (newValue: boolean) => void;
  onConfigurar?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
  required?: boolean;
  isValid?: boolean | ((value: boolean) => boolean);
  ignoreValidations?: boolean;
  invalidText?: string;
  Icon?: React.FC;
  mask?: ToggleMask;
  locked?: boolean;
}

export const ToggleConfigurar: React.FC<ToggleConfigurarProps> = ({
  nome,
  value,
  onChange,
  onConfigurar,
  disabled,
  mask,
  required,
  isValid,
  invalidText,
  ignoreValidations,
  Icon,
  locked,
}) => {
  const { theme } = useTheme();

  const handleConfigurar = (e) => {
    if (value && onConfigurar) {
      onConfigurar(e);
    } else if (!disabled) {
      onChange(!value);
    }
  };

  return (
    <>
      <ContainerToggleConfigurar
        className="containerToggleConfigurar"
        theme={theme}
      >
        {nome && (
          <div className="nome fonteTexto">
            <span>{nome}</span>
            {Icon && <Icon />}
          </div>
        )}
        <Toggle
          isValid={isValid}
          invalidText={invalidText}
          onChange={onChange}
          value={value}
          disabled={disabled}
          required={required}
          ignoreValidations={ignoreValidations}
        />
        <div
          className={`fonteTexto configurar ${value && "ativo"} ${
            !onConfigurar && "hidden"
          }`}
          onClick={handleConfigurar}
        >
          Configurar
        </div>
      </ContainerToggleConfigurar>
    </>
  );
};
